
import React from "react";
import { Button } from "@/components/ui/button";
import { FcGoogle } from "react-icons/fc";
import { Loader2 } from "lucide-react";

interface SocialAuthButtonProps {
  onGoogleLogin: () => Promise<void>;
  loading: boolean;
}

const SocialAuthButton = ({ onGoogleLogin, loading }: SocialAuthButtonProps) => {
  return (
    <div className="flex flex-col">
      <Button
        variant="outline"
        className="flex items-center gap-2 px-6 w-full"
        onClick={onGoogleLogin}
        disabled={loading}
      >
        {loading ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <FcGoogle className="h-5 w-5" />
        )}
        {loading ? "Connecting..." : "Sign in with Google"}
      </Button>
      <p className="text-xs text-gray-500 mt-2 text-center">
        You'll be briefly redirected to Google to sign in securely
      </p>
    </div>
  );
};

export default SocialAuthButton;
